// generated by genversion
export var version = '3.8.22';
//# sourceMappingURL=version.js.map